import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Routes } from '../routes';

export default function ProtectedRoute({ component: Component, render, ...rest }) {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return (
            <Redirect to={{ pathname: Routes.Login.path, state: { from: props.location } }} />
          );
        }
        if (render) return render(props);
        return <Component {...props} />;
      }}
    />
  );
}
